import { Routes } from '@angular/router';

import { CamRoutes } from '@camelot/menu';

export enum EValidationsFlowRoute {
  validationsFlow = 'validationsFlow',
  list = 'list',
}

export const validationsFlowMenuRoutes = {
  key: EValidationsFlowRoute.validationsFlow,
  url: 'validations-flow',
  children: [
    {
      key: EValidationsFlowRoute.list,
      url: 'list',
    },
  ],
};

export const validationsFlowsRoutes = (scope: string): Routes => [
  {
    path: '',
    redirectTo: CamRoutes.getUrl([scope, EValidationsFlowRoute.validationsFlow, EValidationsFlowRoute.list]),
    pathMatch: 'full',
  },
  {
    path: CamRoutes.getUrl([scope, EValidationsFlowRoute.validationsFlow, EValidationsFlowRoute.list]),
    loadComponent: () => import('./pages/list/validations-flow.component').then(c => c.ValidationsFlowPage),
  },
];
